import { FaCubes, FaSearch, FaDraftingCompass, FaShieldAlt } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaCubes />, // Premium Materials icon
        title: 'Premium Materials',
        description: 'Using high-quality construction materials to ensure durability, safety, and longevity.',
    },
    {
        id: 2,
        icon: <FaSearch />, // Site Inspection icon
        title: 'Site Inspection',
        description: 'Thorough site evaluations to identify potential challenges and provide expert recommendations.',
    },
    {
        id: 3,
        icon: <FaDraftingCompass />, // Custom Designs icon
        title: 'Custom Designs',
        description: 'Offering tailored architectural and structural designs to meet your unique requirements.',
    },
    {
        id: 4,
        icon: <FaShieldAlt />, // Strong Foundations icon
        title: 'Strong Foundations',
        description: 'Ensuring solid structural integrity with expertly crafted foundations and frameworks.',
    },
];

export default features;